import { Box, DashboardModule } from '@domain-group/suit-theme'

import useCampaign from '@hooks/useCampaign'
import useFinanceApplications from '@hooks/useFinanceApplications'

import FinanceApplicationListItem from './FinanceApplicationListItem'

const FinanceApplications = (props: { campaignId: number }) => {
  const { campaignId } = props

  const financeApplicationsPayload = useFinanceApplications({
    filters: {
      subject_id: campaignId,
      subject_type: 'Campaign',
    },
    performHttpRequests: !!campaignId,
  })

  const {
    filteredFinanceApplications,
    hasFilteredFinanceApplications,
    loading: loadingFinanceApplications,
  } = financeApplicationsPayload

  const { loading: loadingCampaign } = useCampaign({ id: campaignId })

  const loading = loadingFinanceApplications || loadingCampaign

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      loading={loading}
      title="Finance Applications"
    >
      <Box flexDirection="column">
        {!loading && filteredFinanceApplications.map(financeApplication => (
          <FinanceApplicationListItem financeApplication={financeApplication} key={financeApplication.id} />
        ))}
      </Box>

      {!loading && !hasFilteredFinanceApplications && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Finance Applications Present.
          </DashboardModule.BlankState.Title>
        </DashboardModule.BlankState>
      )}
    </DashboardModule>
  )
}

export default FinanceApplications
